<template>
  <div>
    <el-table
      row-key="id"
      class="scpc-task-table"
      :data="table_config.tableData"
      :cell-class-name="returnName"
      :cell-style="cellStyle"
      :header-cell-style="{
        background: '#f9f9f9',
        fontSize: '16px',
      }"
      :row-style="{ height: '38' }"
      @row-click="rowFun"
      :row-class-name="tableRowClassName"
      lazy
      :load="loadChiTask"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      v-el-table-infinite-scroll="table_config.loadList"
      @selection-change="changeBox"
      border
    >
      <el-table-column v-if="checkbox" type="selection" min-width="10%" />
      <template v-if="tab === 'todoTask'">
        <template v-for="item in table_config.theads" class="scpc-task">
          <!-- taskName列，需要定制化 -->
          <el-table-column
            :key="item.prop"
            v-if="item.prop === 'taskname'"
            :prop="item.prop"
            :label="item.label"
            width="320"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  v-if="scope.row.taskType === '1'"
                  effect="dark"
                  :content="scope.row.nodeName + '-' + scope.row.taskname "
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">
                    {{scope.row.nodeName}}  -  {{scope.row.taskname}}
                  </span>
                </el-tooltip>
                <el-tooltip
                  v-else
                  effect="dark"
                  :content="scope.row.taskname"
                  placement="bottom"
                  popper-class="texttooltip"
                >
                  <span class="scope-content-text">
                    {{scope.row.taskname}}
                  </span>
                </el-tooltip>
                <span class="scpc-operate-icon">
                  <span
                    class="task_within"
                    v-if="scope.row.overdueFlag == 1"
                  >逾</span>
                  <span v-if="scope.row.collectFlag == '1'">
                    <i
                      class="iconfont icon-shoucang1"
                      v-show="scope.row.collectFlag == 1"
                      style="color: #ffb83e; margin-right: 12px"
                    />
                  </span>
                  <span style="padding: 0 6px" v-if="scope.row.milestone === '1'">
                    <i
                      class="iconfont icon-lichengbei-qizhi drawer_icon"
                      v-if="scope.row.milestone == '1'"
                      style="color: #2878ff"
                    />
                  </span>
                  <i
                    class="iconfont icon-liuchengrenwu liuchen_icon"
                    v-if="scope.row.taskType === '1'"
                    @click.stop="config.figureFun(scope.row)"
                    style="
                    color: rgba(28, 106, 235, 1);
                    padding: 0 6px;
                    cursor: pointer;
                  "
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 子任务taskname -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'subtaskTaskname'"
            :prop="item.prop"
            :label="item.label"
            width="140"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.taskname"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.taskname}}</span>
                </el-tooltip>
                <span class="scpc-operate-icon">
                  <span
                    class="task_within"
                    v-if="scope.row.overdueFlag == 1"
                  >逾</span>
                  <span v-if="scope.row.collectFlag == '1'">
                    <i
                      class="iconfont icon-shoucang1"
                      v-show="scope.row.collectFlag == 1"
                      style="color: #ffb83e; margin-right: 12px"
                    />
                  </span>
                  <span style="padding: 0 6px" v-if="scope.row.milestone === '1'">
                    <i
                      class="iconfont icon-lichengbei-qizhi drawer_icon"
                      v-if="scope.row.milestone == '1'"
                      style="color: #2878ff"
                    />
                  </span>
                  <i
                    class="iconfont icon-liuchengrenwu liuchen_icon"
                    v-if="scope.row.taskType === '1'"
                    @click.stop="config.figureFun(scope.row)"
                    style="
                    color: rgba(28, 106, 235, 1);
                    padding: 0 6px;
                    cursor: pointer;
                  "
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 关联任务Taskname -->
          <el-table-column
            v-else-if="item.prop === 'correlationTaskname'"
            :prop="item.prop"
            :key="item.prop"
            :label="item.label"
            min-width="35%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.taskVo.taskname"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.taskVo.taskname}}</span>
                </el-tooltip>
                <!-- <span class="scope-content-text">{{scope.row.taskVo.taskname}}</span> -->
                <span class="scpc-operate-icon">
                  <span
                    class="task_within"
                    v-if="scope.row.taskVo.overdueFlag == 1"
                  >逾</span>
                  <span v-if="scope.row.taskVo.collectFlag == '1'">
                    <i
                      class="iconfont icon-shoucang1"
                      v-show="scope.row.taskVo.collectFlag == 1"
                      style="color: #ffb83e; margin-right: 12px"
                    />
                  </span>
                  <span style="padding: 0 6px" v-if="scope.row.taskVo.milestone === '1'">
                    <i
                      class="iconfont icon-lichengbei-qizhi drawer_icon"
                      v-if="scope.row.taskVo.milestone == '1'"
                      style="color: #2878ff"
                    />
                  </span>
                  <i
                    class="iconfont icon-liuchengrenwu liuchen_icon"
                    v-if="scope.row.taskVo.taskType === '1'"
                    @click.stop="config.figureFun(scope.row.taskVo)"
                    style="
                    color: rgba(28, 106, 235, 1);
                    padding: 0 6px;
                    cursor: pointer;
                  "
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 任务编号 -->
          <el-table-column
            v-else-if="item.prop === 'taskNumber'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            width="170"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <span class="scope-content-id">{{scope.row.taskNumber}}</span>
            </template>
          </el-table-column>
          <!-- 截止时间 -->
          <el-table-column
            v-else-if="item.prop === 'planEndDate'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="45%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <!-- corpId === 'ding379884b8b194a55f35c2f4657eb6378f' -->
              <span class="scope-content-id" v-if="corpId === 'ding379884b8b194a55f35c2f4657eb6378f'&&scope.row.project ">{{scope.row.project.planEndDate.substring(0, 10)}}</span>
              <span class="scope-content-id" v-else>{{scope.row.proNumber && scope.row.planEndDate
                ? scope.row.planEndDate.substring(0, 10)
                : scope.row.planEndDate}}</span>
            </template>
          </el-table-column>
          <!-- 预计完成时间 -->
          <el-table-column
            v-else-if="item.prop === 'prodPlanEndDate'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="45%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope" v-if="scope.row.prodPlanEndDate">
              <span class="scope-content-id">{{scope.row.prodPlanEndDate.substring(0, 10)}}</span>
            </template>
          </el-table-column>
          <!-- 子任务截止时间 -->
          <el-table-column
            v-else-if="item.prop === 'subtaskPlanEndDate'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            width="220"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <span class="scope-content-id">{{scope.row.proNumber && scope.row.planEndDate
                ? scope.row.planEndDate.substring(0, 10)
                : scope.row.planEndDate}}</span>
            </template>
          </el-table-column>
          <!-- 创建人 -->
          <el-table-column
            v-else-if="item.prop === 'createUser'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="30%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <!-- 头像 -->
                <div class="scpc-operate-photo" style="padding-right: 2px">
                  <div
                    v-if="
                      scope.row.createUser && scope.row.createUser.avatar != '' && scope.row.createUser.avatar !== null
                    "
                  >
                    <img class="img" :src="scope.row.createUser.avatar">
                  </div>
                  <div
                    class="img"
                    v-else
                  >
                    {{scope.row.createUser.name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.createUser.name" />
                </span>
                <span class="scope-content-text" v-else>{{scope.row.createUser.name}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 子任务创建人 -->
          <el-table-column
            v-else-if="item.prop === 'subtaskCreateUser'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="28%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <!-- 头像 -->
                <div class="scpc-operate-photo" style="padding-right: 2px">
                  <div
                    v-if="
                      scope.row.createUser && scope.row.createUser.avatar != '' && scope.row.createUser.avatar !== null
                    "
                  >
                    <img class="img" :src="scope.row.createUser.avatar">
                  </div>
                  <div
                    class="img"
                    v-else
                  >
                    {{scope.row.createUser.name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.createUser.name" />
                </span>
                <span class="scope-content-text" v-else>{{scope.row.createUser.name}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 关联任务创建人 -->
          <el-table-column
            v-else-if="item.prop === 'correlationCreateUser'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="28%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <!-- 头像 -->
                <div class="scpc-operate-photo" style="padding-right: 2px">
                  <div
                    v-if="
                      scope.row.taskVo.createUser && scope.row.taskVo.createUser.avatar != ''&& scope.row.taskVo.createUser.avatar !== null
                    "
                  >
                    <img class="img" :src="scope.row.taskVo.createUser.avatar">
                  </div>
                  <div
                    class="img"
                    v-else
                  >
                    {{scope.row.taskVo.createUser.name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.taskVo.createUser.name" />
                </span>
                <span class="scope-content-text" v-else>{{scope.row.taskVo.createUser.name}}</span>
                <!-- <span class="scope-content-text" v-if="scope.row.taskVo.createUser">{{scope.row.taskVo.createUser.name}}</span> -->
              </div>
            </template>
          </el-table-column>
          <!-- 负责人 -->
          <el-table-column
            v-else-if="item.prop === 'principalUser'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            width="120"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <!-- 头像 -->
                <div class="scpc-operate-photo">
                  <div
                    v-if="
                      scope.row.principalUser.avatar &&
                        scope.row.principalUser.avatar != '' && scope.row.principalUser.avatar != null
                    "
                  >
                    <img class="img" :src="scope.row.principalUser.avatar">
                  </div>
                  <div class="img" v-else>
                    {{scope.row.principalUser.name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.principalUser.name" />
                </span>
                <span class="scope-content-text" v-else>{{scope.row.principalUser.name}}</span>
                <!-- <span class="scope-content-text">{{scope.row.principalUser.name}}</span> -->
              </div>
            </template>
          </el-table-column>
          <!-- 当前执行人 -->
          <el-table-column
            v-else-if="item.prop === 'executorUserList'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="30%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div
                style="
                display: flex;
                overflow: hidden;
                align-items: center;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              >
                <div class="scpc-operate-photos">
                  <div style="display: flex; width: 6px">
                    <div
                      class="scope-content"
                      v-for="(item1, index) in scope.row.executorUserList"
                      :key="index"
                    >
                      <!-- 头像 -->
                      <div class="scpc-operate-photo">
                        <div v-if="item1.avatar && item1.avatar != ''&& item1.avatar != null">
                          <img :src="item1.avatar">
                        </div>
                        <div class="img" v-else>
                          {{item1.name.substring(0, 1)}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                  display: flex;
                  align-items: center;
                  min-width: 55px;
                "
                >
                  <div
                    style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-left: 8px;
                  "
                  >
                    <span
                      v-for="(item1, index) in scope.row.executorUserList"
                      :key="index"
                    >
                      <span class="scope-content-text">
                        <!-- <span>{{item1.name}}</span> -->
                        <span v-if="channel === 'wechat'">
                          <ww-open-data type="userName" :openid="item1.name" />
                        </span>
                        <span v-else>{{item1.name}}</span>
                        <span v-if="index<(scope.row.executorUserList.length-1)" style="margin-right:5px">,</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 计划工时 -->
          <el-table-column
            v-else-if="item.prop === 'planWorkTime'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="33%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <div v-if="scope.row.planWorkTime == null || scope.row.planWorkTime == ''">
                  <span class="scope-content-text">{{scope.row.planWorkTime}}</span>
                <!-- <span>天</span> -->
                </div>
                <div v-else>
                  <span class="scope-content-text">{{scope.row.planWorkTime}}</span>
                  <span>天</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 任务类型 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'taskType'"
            :prop="item.prop"
            :label="item.label"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{scope.row.proTypeId}} -->
              <div class="scope-content" style="justify-content:center">
                <span v-if="scope.row.proTypeId === '2001'">敏捷任务</span>
                <span v-else-if="scope.row.taskType === '0'">标准任务</span>
                <span v-else-if="scope.row.taskType === '1'">流程任务</span>
                <span v-else-if="scope.row.proTypeId === '0'">标准任务</span>
                <span v-else-if="scope.row.proTypeId === '1'">流程任务</span>
                <span
                  class="scope-content-text"
                  v-if="scope.row.taskType < '0'"
                >{{scope.row.taskType}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 任务列表项目名称 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'taskProname'"
            :prop="item.prop"
            :label="item.label"
            width="150"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.proId !== '0'">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.project.proname"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.project.proname}}</span>
                </el-tooltip>
              </div>
              <div class="scope-content" v-else>
                <span class="scope-content-text" />
              </div>
            </template>
          </el-table-column>
          <!-- 关联任务类型 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'correlationtaskType'"
            :prop="item.prop"
            :label="item.label"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{scope.row}} -->
              <div class="scope-content" style="justify-content:center">
                <span v-if="scope.row.taskVo.proTypeId === '2001'">敏捷任务</span>
                <span v-else-if="scope.row.taskVo.taskType === '0'">标准任务</span>
                <span v-else-if="scope.row.taskVo.taskType === '1'">流程任务</span>
                <span v-else-if="scope.row.taskVo.proTypeId === '0'">标准任务</span>
                <span v-else-if="scope.row.taskVo.proTypeId === '1'">流程任务</span>
                <span
                  class="scope-content-text"
                  v-if="scope.row.taskVo.taskType < '0'"
                >{{scope.row.taskVo.taskType}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 任务状态 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'status'"
            :prop="item.prop"
            :label="item.label"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span>{{getStatusText(scope.row)}}</span>
              </div>
            </template>
          </el-table-column>

          <!-- 子任务任务状态 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'subtaskStatus'"
            :prop="item.prop"
            :label="item.label"
            width="190"
            align="center"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span>{{getStatusText(scope.row)}}</span>
              </div>
            </template>
          </el-table-column>

          <!-- 关联任务任务状态 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'correlationstatus'"
            :prop="item.prop"
            :label="item.label"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span>{{getStatusText(scope.row.taskVo)}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 关联任务操作 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'associated' && table_config.delFlag != '2'"
            :prop="item.prop"
            :label="item.label"
            min-width="15%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span>
                  <i
                    class="iconfont icon-jiechuguanlianxiang"
                    style="cursor: pointer"
                    @click.stop="dissociated(scope.row.objectId)"
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 文件名称 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'fileName'"
            :prop="item.prop"
            :label="item.label"
            min-width="40%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.fileName"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.fileName}}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- 文件类型 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'fileFormat'"
            :prop="item.prop"
            :label="item.label"
            min-width="40%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span
                  v-for="(text, index) in getTypeTexts(scope.row.type)"
                  :key="index"
                  class="scope-content-text"
                >
                  {{text}}
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 节点名称 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'nodeName'"
            :prop="item.prop"
            :label="item.label"
            min-width="40%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.nodeName"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.nodeName}}</span>
                </el-tooltip>

              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'createDate'"
            :prop="item.prop"
            :label="item.label"
            min-width="35%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span class="scope-content-text">{{scope.row.createDate.substring(0, 10)}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 删除文件 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'delete' && table_config.delFlag != '2'"
            :prop="item.prop"
            :label="item.label"
            min-width="30%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  content="权限设置"
                  placement="top"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <i class="iconfont icon-quanxianshezhi custom_icon" @click.stop="setFile(scope.row)" style="color:#909090;cursor: pointer;margin-right:15px" />
                </el-tooltip>
                <el-tooltip effect="dark" popper-class="texttooltip" content="删除文件" placement="top" :open-delay="500">
                  <span v-if="corpId === 'wpbcaOGAAAJFN7JTFH_DOhACICDp_PUg'">
                    <i
                      v-if="drawer.info.editFlag === true"
                      class="iconfont icon-shanchu1"
                      style="cursor: pointer"
                      @click.stop="deleFile(scope.row)"
                    />
                  </span>

                  <span v-else>
                    <i
                      class="iconfont icon-shanchu1"
                      style="cursor: pointer"
                      @click.stop="deleFile(scope.row)"
                    />
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'deletePro' && table_config.delFlag != '2'"
            :prop="item.prop"
            :label="item.label"
            min-width="30%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  content="权限设置"
                  placement="top"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <i class="iconfont icon-quanxianshezhi custom_icon" @click.stop="setFile(scope.row)" style="color:#909090;cursor: pointer;margin-right:15px;margin-left:10px" />
                </el-tooltip>
                <el-tooltip effect="dark" popper-class="texttooltip" content="删除文件" placement="top" :open-delay="500">
                  <i
                    v-if="drawer.info.nodeStatus !== '2' && UserData.corpId !== 'wpbcaOGAAAJFN7JTFH_DOhACICDp_PUg'"
                    class="iconfont icon-shanchu1"
                    style="cursor: pointer"
                    @click.stop="deleFile(scope.row)"
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- 工作进度 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'proRate'"
            :prop="item.prop"
            :label="item.label"
            min-width="35%"
          >
            <template slot-scope="scope">
              <div class="scope-content" style="margin-left:20px">
                {{scope.row.progressRate}}%
              </div>
            </template>
          </el-table-column>
          <!-- 循环次数 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'cycleNumber'"
            :prop="item.prop"
            :label="item.label"
            min-width="25%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                第{{scope.$index+1}}次
              </div>
            </template>
          </el-table-column>
          <!-- 循环记录实际工期 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'realityWorkTime'"
            :prop="item.prop"
            :label="item.label"
            min-width="25%"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.realityWorkTime">
                {{scope.row.realityWorkTime}}天
              </div>
              <div class="scope-content" v-else-if="!scope.row.realityWorkTime">
                {{scope.row.realityWorkTime}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'nodeCreateDate'"
            :prop="item.prop"
            :label="item.label"
            min-width="35%"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.createDate">
                {{scope.row.createDate.substring(0, 10)}}
              </div>
            </template>
          </el-table-column>
          <!-- 剩余工期 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'remainDays'"
            :prop="item.prop"
            :label="item.label"
            min-width="25%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                {{scope.row.remainDays}}
              </div>
            </template>
          </el-table-column>
          <!-- 订金时间 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'depositDate'"
            :prop="item.prop"
            :label="item.label"
            min-width="45%"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.depositDate">
                {{scope.row.depositDate.substring(0, 10)}}
              </div>
            </template>
          </el-table-column>
          <!-- 图纸确认时间 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'drawingDate'"
            :prop="item.prop"
            :label="item.label"
            min-width="45%"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.drawingDate">
                {{scope.row.drawingDate.substring(0, 10)}}
              </div>
            </template>
          </el-table-column>
          <!-- 当前节点 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'flowNames'"
            :prop="item.prop"
            :label="item.label"
            min-width="45%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.flowNames"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.nodeName}}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- 其他列 -->
          <el-table-column
            v-else
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="35%"
            :render-header="item.render_header"
          />
        </template>
      </template>
      <template v-else>
        <template v-for="item in table_config.thead" class="scpc-task">
          <!-- taskName列，需要定制化 -->
          <el-table-column
            :key="item.prop"
            v-if="item.prop === 'taskname'"
            :prop="item.prop"
            :label="item.label"
            min-width="45%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.taskname"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">
                    {{scope.row.taskname}}
                  </span>
                </el-tooltip>
                <span class="scpc-operate-icon">
                  <span
                    class="task_within"
                    v-if="scope.row.overdueFlag == 1"
                  >逾</span>
                  <span v-if="scope.row.collectFlag == '1'">
                    <i
                      class="iconfont icon-shoucang1"
                      v-show="scope.row.collectFlag == 1"
                      style="color: #ffb83e; margin-right: 12px"
                    />
                  </span>
                  <span style="padding: 0 6px" v-if="scope.row.milestone === '1'">
                    <i
                      class="iconfont icon-lichengbei-qizhi drawer_icon"
                      v-if="scope.row.milestone == '1'"
                      style="color: #2878ff"
                    />
                  </span>
                  <i
                    class="iconfont icon-liuchengrenwu liuchen_icon"
                    v-if="scope.row.taskType === '1'"
                    @click.stop="config.figureFun(scope.row)"
                    style="
                    color: rgba(28, 106, 235, 1);
                    padding: 0 6px;
                    cursor: pointer;
                  "
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 子任务taskname -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'subtaskTaskname'"
            :prop="item.prop"
            :label="item.label"
            width="140"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.taskname"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.taskname}}</span>
                </el-tooltip>
                <span class="scpc-operate-icon">
                  <span
                    class="task_within"
                    v-if="scope.row.overdueFlag == 1"
                  >逾</span>
                  <span v-if="scope.row.collectFlag == '1'">
                    <i
                      class="iconfont icon-shoucang1"
                      v-show="scope.row.collectFlag == 1"
                      style="color: #ffb83e; margin-right: 12px"
                    />
                  </span>
                  <span style="padding: 0 6px" v-if="scope.row.milestone === '1'">
                    <i
                      class="iconfont icon-lichengbei-qizhi drawer_icon"
                      v-if="scope.row.milestone == '1'"
                      style="color: #2878ff"
                    />
                  </span>
                  <i
                    class="iconfont icon-liuchengrenwu liuchen_icon"
                    v-if="scope.row.taskType === '1'"
                    @click.stop="config.figureFun(scope.row)"
                    style="
                    color: rgba(28, 106, 235, 1);
                    padding: 0 6px;
                    cursor: pointer;
                  "
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 关联任务Taskname -->
          <el-table-column
            v-else-if="item.prop === 'correlationTaskname'"
            :prop="item.prop"
            :key="item.prop"
            :label="item.label"
            min-width="35%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.taskVo.taskname"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.taskVo.taskname}}</span>
                </el-tooltip>
                <!-- <span class="scope-content-text">{{scope.row.taskVo.taskname}}</span> -->
                <span class="scpc-operate-icon">
                  <span
                    class="task_within"
                    v-if="scope.row.taskVo.overdueFlag == 1"
                  >逾</span>
                  <span v-if="scope.row.taskVo.collectFlag == '1'">
                    <i
                      class="iconfont icon-shoucang1"
                      v-show="scope.row.taskVo.collectFlag == 1"
                      style="color: #ffb83e; margin-right: 12px"
                    />
                  </span>
                  <span style="padding: 0 6px" v-if="scope.row.taskVo.milestone === '1'">
                    <i
                      class="iconfont icon-lichengbei-qizhi drawer_icon"
                      v-if="scope.row.taskVo.milestone == '1'"
                      style="color: #2878ff"
                    />
                  </span>
                  <i
                    class="iconfont icon-liuchengrenwu liuchen_icon"
                    v-if="scope.row.taskVo.taskType === '1'"
                    @click.stop="config.figureFun(scope.row.taskVo)"
                    style="
                    color: rgba(28, 106, 235, 1);
                    padding: 0 6px;
                    cursor: pointer;
                  "
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 任务编号 -->
          <el-table-column
            v-else-if="item.prop === 'taskNumber'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            width="170"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <span class="scope-content-id">{{scope.row.taskNumber}}</span>
            </template>
          </el-table-column>
          <!-- taskName列，需要定制化 项目名称 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'proname'"
            :prop="item.prop"
            :label="item.label"
            width="110"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.proname"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.proname}}</span>
                </el-tooltip>
                <!-- TODO 里程碑/ -->
                <span class="scpc-operate-icon">
                  <i
                    class="iconfont icon-shoucang1"
                    v-show="scope.row.collectFlag == 1"
                    style="color: #ffb83e; margin-right: 12px"
                  />
                  <i
                    class="iconfont icon-lichengbei-qizhi"
                    style="color: #2978ff; margin-right: 12px"
                    v-show="scope.row.collect"
                  />
                  <i
                    class="iconfont icon-liuchengrenwu"
                    @click.stop="config.figureFun(scope.row)"
                    style="color: rgba(28, 106, 235, 1)"
                    v-show="scope.row.collect"
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 项目编号 -->
          <el-table-column
            v-else-if="item.prop === 'proNumber'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            width="220"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <span class="scope-content-id">{{scope.row.proNumber}}</span>
            </template>
          </el-table-column>
          <!-- 开始时间 -->
          <el-table-column
            v-else-if="item.prop === 'planStartDate'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="33%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <span class="scope-content-id">{{scope.row.proNumber && scope.row.planStartDate
                ? scope.row.planStartDate.substring(0, 10)
                : scope.row.planStartDate}}</span>
            </template>
          </el-table-column>
          <!-- 截止时间 -->
          <el-table-column
            v-else-if="item.prop === 'planEndDate'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="45%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <!-- corpId === 'ding379884b8b194a55f35c2f4657eb6378f' -->
              <span class="scope-content-id" v-if="corpId === 'ding379884b8b194a55f35c2f4657eb6378f'&&scope.row.project ">{{scope.row.project.planEndDate.substring(0, 10)}}</span>
              <span class="scope-content-id" v-else>{{scope.row.proNumber && scope.row.planEndDate
                ? scope.row.planEndDate.substring(0, 10)
                : scope.row.planEndDate}}</span>
            </template>
          </el-table-column>
          <!-- 预计完成时间 -->
          <el-table-column
            v-else-if="item.prop === 'prodPlanEndDate'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="45%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope" v-if="scope.row.prodPlanEndDate">
              <span class="scope-content-id">{{scope.row.prodPlanEndDate.substring(0, 10)}}</span>
            </template>
          </el-table-column>
          <!-- 子任务截止时间 -->
          <el-table-column
            v-else-if="item.prop === 'subtaskPlanEndDate'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            width="220"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <span class="scope-content-id">{{scope.row.proNumber && scope.row.planEndDate
                ? scope.row.planEndDate.substring(0, 10)
                : scope.row.planEndDate}}</span>
            </template>
          </el-table-column>
          <!-- 创建人 -->
          <el-table-column
            v-else-if="item.prop === 'createUser'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="30%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <!-- 头像 -->
                <div class="scpc-operate-photo" style="padding-right: 2px">
                  <div
                    v-if="
                      scope.row.createUser && scope.row.createUser.avatar != '' && scope.row.createUser.avatar != null
                    "
                  >
                    <img class="img" :src="scope.row.createUser.avatar">
                  </div>
                  <div
                    class="img"
                    v-else
                  >
                    {{scope.row.createUser.name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.createUser.name" />
                </span>
                <span class="scope-content-text" v-else-if="scope.row.createUser && channel !== 'wechat'">{{scope.row.createUser.name}}</span>
                <!-- <span class="scope-content-text" v-if="scope.row.createUser">{{scope.row.createUser.name}}</span> -->
              </div>
            </template>
          </el-table-column>
          <!-- 子任务创建人 -->
          <el-table-column
            v-else-if="item.prop === 'subtaskCreateUser'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="28%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <!-- 头像 -->
                <div class="scpc-operate-photo" style="padding-right: 2px">
                  <div
                    v-if="
                      scope.row.createUser && scope.row.createUser.avatar != '' && scope.row.createUser.avatar != null
                    "
                  >
                    <img class="img" :src="scope.row.createUser.avatar">
                  </div>
                  <div
                    class="img"
                    v-else
                  >
                    {{scope.row.createUser.name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.createUser.name" />
                </span>
                <span class="scope-content-text" v-else>{{scope.row.createUser.name}}</span>
                <!-- <span class="scope-content-text" v-if="scope.row.createUser">{{scope.row.createUser.name}}</span> -->
              </div>
            </template>
          </el-table-column>
          <!-- 关联任务创建人 -->
          <el-table-column
            v-else-if="item.prop === 'correlationCreateUser'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="28%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <!-- 头像 -->
                <div class="scpc-operate-photo" style="padding-right: 2px">
                  <div
                    v-if="
                      scope.row.taskVo.createUser && scope.row.taskVo.createUser.avatar != ''&& scope.row.taskVo.createUser.avatar != null
                    "
                  >
                    <img class="img" :src="scope.row.taskVo.createUser.avatar">
                  </div>
                  <div
                    class="img"
                    v-else
                  >
                    {{scope.row.taskVo.createUser.name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.taskVo.createUser.name" />
                </span>
                <span class="scope-content-text" v-else>{{scope.row.taskVo.createUser.name}}</span>
                <!-- <span class="scope-content-text" v-if="scope.row.taskVo.createUser">{{scope.row.taskVo.createUser.name}}</span> -->
              </div>
            </template>
          </el-table-column>
          <!-- 负责人 -->
          <el-table-column
            v-else-if="item.prop === 'principalUser'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            width="120"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <!-- 头像 -->
                <div class="scpc-operate-photo">
                  <div
                    v-if="
                      scope.row.principalUser.avatar &&
                        scope.row.principalUser.avatar != '' && scope.row.principalUser.avatar != null
                    "
                  >
                    <img class="img" :src="scope.row.principalUser.avatar">
                  </div>
                  <div class="img" v-else>
                    {{scope.row.principalUser.name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.principalUser.name" />
                </span>
                <span class="scope-content-text">{{scope.row.principalUser.name}}</span>
                <!-- <span class="scope-content-text">{{scope.row.principalUser.name}}</span> -->
              </div>
            </template>
          </el-table-column>
          <!-- 当前执行人 -->
          <el-table-column
            v-else-if="item.prop === 'executorUserList'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="30%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div
                style="
                display: flex;
                overflow: hidden;
                align-items: center;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              >
                <div class="scpc-operate-photos">
                  <div style="display: flex; width: 6px">
                    <div
                      class="scope-content"
                      v-for="(item1, index) in scope.row.executorUserList"
                      :key="index"
                    >
                      <!-- 头像 -->
                      <div class="scpc-operate-photo">
                        <div v-if="item1.avatar && item1.avatar != ''&& item1.avatar != null">
                          <img :src="item1.avatar">
                        </div>
                        <div class="img" v-else>
                          {{item1.name.substring(0, 1)}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                  display: flex;
                  align-items: center;
                  min-width: 55px;
                "
                >
                  <div
                    style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-left: 8px;
                  "
                  >
                    <span
                      v-for="(item1, index) in scope.row.executorUserList"
                      :key="index"
                    >
                      <span class="scope-content-text">
                        <!-- <span>{{item1.name}}</span> -->
                        <span v-if="channel === 'wechat'">
                          <ww-open-data type="userName" :openid="item1.name" />
                        </span>
                        <span v-else>{{item1.name}}</span>
                        <span v-if="index<(scope.row.executorUserList.length-1)" style="margin-right:5px">,</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 计划工时 -->
          <el-table-column
            v-else-if="item.prop === 'planWorkTime'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="33%"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <div v-if="scope.row.planWorkTime == '' || scope.row.planWorkTime == null">
                  <span class="scope-content-text">{{scope.row.planWorkTime}}</span>
                <!-- <span>天</span> -->
                </div>
                <div v-else>
                  <span class="scope-content-text">{{scope.row.planWorkTime}}</span>
                  <span>天</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 任务类型 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'taskType'"
            :prop="item.prop"
            :label="item.label"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{scope.row.proTypeId}} -->
              <div class="scope-content" style="justify-content:center">
                <span v-if="scope.row.proTypeId === '2001'">敏捷任务</span>
                <span v-else-if="scope.row.taskType === '0'">标准任务</span>
                <span v-else-if="scope.row.taskType === '1'">流程任务</span>
                <span v-else-if="scope.row.proTypeId === '0'">标准任务</span>
                <span v-else-if="scope.row.proTypeId === '1'">流程任务</span>
                <span
                  class="scope-content-text"
                  v-if="scope.row.taskType < '0'"
                >{{scope.row.taskType}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 任务列表项目名称 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'taskProname'"
            :prop="item.prop"
            :label="item.label"
            width="150"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.proId !== '0'">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.project.proname"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.project.proname}}</span>
                </el-tooltip>
              </div>
              <div class="scope-content" v-else>
                <span class="scope-content-text" />
              </div>
            </template>
          </el-table-column>
          <!-- 关联任务类型 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'correlationtaskType'"
            :prop="item.prop"
            :label="item.label"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{scope.row}} -->
              <div class="scope-content" style="justify-content:center">
                <span v-if="scope.row.taskVo.proTypeId === '2001'">敏捷任务</span>
                <span v-else-if="scope.row.taskVo.taskType === '0'">标准任务</span>
                <span v-else-if="scope.row.taskVo.taskType === '1'">流程任务</span>
                <span v-else-if="scope.row.taskVo.proTypeId === '0'">标准任务</span>
                <span v-else-if="scope.row.taskVo.proTypeId === '1'">流程任务</span>
                <span
                  class="scope-content-text"
                  v-if="scope.row.taskVo.taskType < '0'"
                >{{scope.row.taskVo.taskType}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 任务状态 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'status'"
            :prop="item.prop"
            :label="item.label"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span>{{getStatusText(scope.row)}}</span>
              </div>
            </template>
          </el-table-column>

          <!-- 子任务任务状态 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'subtaskStatus'"
            :prop="item.prop"
            :label="item.label"
            width="190"
            align="center"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span>{{getStatusText(scope.row)}}</span>
              </div>
            </template>
          </el-table-column>

          <!-- 关联任务任务状态 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'correlationstatus'"
            :prop="item.prop"
            :label="item.label"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span>{{getStatusText(scope.row.taskVo)}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 项目列表 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'projectName'"
            :prop="item.prop"
            :label="item.label"
            width="270"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span class="scope-content-text">{{scope.row.projectName}}</span>
                <!-- TODO 里程碑/ -->
                <span class="scpc-operate-icon">
                  <i
                    class="iconfont icon-shoucang1"
                    style="color: #ffb83e; margin-right: 12px"
                    v-show="scope.row.collect"
                  />
                  <i
                    class="iconfont icon-lichengbei-qizhi"
                    style="color: #2978ff; margin-right: 12px"
                    v-show="scope.row.collect"
                  />
                  <i
                    class="iconfont icon-liuchengrenwu"
                    @click.stop="config.figureFun(scope.row)"
                    style="color: rgba(28, 106, 235, 1)"
                    v-show="scope.row.collect"
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 项目完成lv -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'complete'"
            :prop="item.prop"
            :label="item.label"
            width="220"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <!-- <span class="scope-content-text">{{scope.row.taskCount!==0&&scope.row.completeTaskCount!==0&&(scope.row.taskCount-scope.row.stopTaskCount)!=0?(scope.row.completeTaskCount / (scope.row.taskCount - scope.row.stopTaskCount))*100:0}}</span> -->
                <!-- 滑块 -->
                <el-progress
                  style="width: 300px"
                  :stroke-width="12"
                  :percentage="scope.row.progressRate"
                  color="#2878ff"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'projectSTime'"
            :prop="item.prop"
            :label="item.label"
            width="200"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span class="scope-content-text">{{scope.row.projectSTime}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'projecteTime'"
            :prop="item.prop"
            :label="item.label"
            width="200"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span class="scope-content-text">{{scope.row.projecteTime}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 关联任务操作 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'associated' && table_config.delFlag != '2'"
            :prop="item.prop"
            :label="item.label"
            min-width="15%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span>
                  <i
                    class="iconfont icon-jiechuguanlianxiang"
                    style="cursor: pointer"
                    @click.stop="dissociated(scope.row.objectId)"
                  />
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 文件名称 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'fileName'"
            :prop="item.prop"
            :label="item.label"
            min-width="40%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.fileName"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.fileName}}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- 文件类型 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'fileFormat'"
            :prop="item.prop"
            :label="item.label"
            min-width="40%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span
                  v-for="(text, index) in getTypeTexts(scope.row.type)"
                  :key="index"
                  class="scope-content-text"
                >
                  {{text}}
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 节点名称 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'nodeName'"
            :prop="item.prop"
            :label="item.label"
            min-width="40%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.nodeName"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.nodeName}}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'createDate'"
            :prop="item.prop"
            :label="item.label"
            min-width="35%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <span class="scope-content-text">{{scope.row.createDate.substring(0, 10)}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 删除文件 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'delete' && table_config.delFlag != '2'"
            :prop="item.prop"
            :label="item.label"
            min-width="30%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  content="权限设置"
                  placement="top"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <i class="iconfont icon-quanxianshezhi custom_icon" @click.stop="setFile(scope.row)" style="color:#909090;cursor: pointer;margin-right:15px" />
                </el-tooltip>
                <el-tooltip effect="dark" popper-class="texttooltip" content="删除文件" placement="top" :open-delay="500">
                  <span v-if="corpId === 'wpbcaOGAAAJFN7JTFH_DOhACICDp_PUg'">
                    <i
                      v-if="drawer.info.editFlag === true"
                      class="iconfont icon-shanchu1"
                      style="cursor: pointer"
                      @click.stop="deleFile(scope.row)"
                    />
                  </span>
                  <span v-else>
                    <i
                      v-if="drawer.info.status !== '2'"
                      class="iconfont icon-shanchu1"
                      style="cursor: pointer"
                      @click.stop="deleFile(scope.row)"
                    />
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'deletePro' && table_config.delFlag != '2'"
            :prop="item.prop"
            :label="item.label"
            min-width="30%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  content="权限设置"
                  placement="top"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <i class="iconfont icon-quanxianshezhi custom_icon" @click.stop="setFile(scope.row)" style="color:#909090;cursor: pointer;margin-right:15px;margin-left:10px" />
                </el-tooltip>
                <el-tooltip effect="dark" popper-class="texttooltip" content="删除文件" placement="top" :open-delay="500">
                  <i
                    v-if="drawer.info.nodeStatus && drawer.info.nodeStatus !== '2' && UserData.corpId !== 'wpbcaOGAAAJFN7JTFH_DOhACICDp_PUg'"
                    class="iconfont icon-shanchu1"
                    style="cursor: pointer"
                    @click.stop="deleFile(scope.row)"
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- 工作进度 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'proRate'"
            :prop="item.prop"
            :label="item.label"
            min-width="30%"
          >
            <template slot-scope="scope">
              <div class="scope-content" style="margin-left:20px">
                {{scope.row.progressRate}}%
              </div>
            </template>
          </el-table-column>
          <!-- 循环次数 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'cycleNumber'"
            :prop="item.prop"
            :label="item.label"
            min-width="25%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                第{{scope.$index+1}}次
              </div>
            </template>
          </el-table-column>
          <!-- 循环记录实际工期 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'realityWorkTime'"
            :prop="item.prop"
            :label="item.label"
            min-width="25%"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.realityWorkTime">
                {{scope.row.realityWorkTime}}天
              </div>
              <div class="scope-content" v-else-if="!scope.row.realityWorkTime">
                {{scope.row.realityWorkTime}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'nodeCreateDate'"
            :prop="item.prop"
            :label="item.label"
            min-width="35%"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.createDate">
                {{scope.row.createDate.substring(0, 10)}}
              </div>
            </template>
          </el-table-column>
          <!-- 剩余工期 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'remainDays'"
            :prop="item.prop"
            :label="item.label"
            min-width="25%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                {{scope.row.remainDays}}
              </div>
            </template>
          </el-table-column>
          <!-- 订金时间 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'depositDate'"
            :prop="item.prop"
            :label="item.label"
            min-width="45%"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.depositDate">
                {{scope.row.depositDate.substring(0, 10)}}
              </div>
            </template>
          </el-table-column>
          <!-- 图纸确认时间 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'drawingDate'"
            :prop="item.prop"
            :label="item.label"
            min-width="45%"
          >
            <template slot-scope="scope">
              <div class="scope-content" v-if="scope.row.drawingDate">
                {{scope.row.drawingDate.substring(0, 10)}}
              </div>
            </template>
          </el-table-column>
          <!-- 当前节点 -->
          <el-table-column
            :key="item.prop"
            v-else-if="item.prop === 'flowNames'"
            :prop="item.prop"
            :label="item.label"
            min-width="35%"
          >
            <template slot-scope="scope">
              <div class="scope-content">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.flowNames"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <span class="scope-content-text">{{scope.row.flowNames}}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- 其他列 -->
          <el-table-column
            v-else
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            min-width="35%"
            :render-header="item.render_header"
          />
        </template>
      </template>
    </el-table>
  </div>
</template>

<script>
import { getTaskList, delTaskRelation } from '../../utils/api/task'
import { delFile } from '../../utils/api/file'
export default {
  name: 'TabComponent',
  // eslint-disable-next-line vue/no-unused-components
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    taskid: {
      type: String,
      default: ''
    },
    // 复选框
    checkbox: Boolean,
    // url地址
    url: {
      type: String,
      default: '',
      require: true
    },
    // 数据类型
    method: {
      type: String,
      default: 'post',
      require: true
    },
    data: {
      type: Object,
      default: () => ({})
    },
    shou: {
      type: Boolean,
      default: true
    },
    tab: {
      type: String,
      default: ''
    },
    // 侧边栏数据
    drawer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
      UserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      sels: [], // 选中的值显示
      check_list: [],
      // 表格配置
      table_config: {
        thead: [],
        tableData: []
      },
      clientHeights: document.documentElement.clientHeight,
      statusTexts: {
        taskType: {
          '0': {
            '0': '未指派',
            '1': '未完成',
            '2': '已完成',
            '3': '待确认',
            '4': '已终止'
          },
          '1': {
            '0': '未开始',
            '1': '未完成',
            '2': '已完成',
            '3': '待确认'
          }
        },
        proTypeId: {
          '2001': {
            '0': '需求池',
            '1': '开发中',
            '5': '待测试',
            '3': '测试中',
            '6': '待验收',
            '2': '验收完成',
            '4': '已终止'
          },
          '0': {
            '0': '未指派',
            '1': '未完成',
            '2': '已完成',
            '3': '待确认',
            '4': '已终止'
          },
          '1': {
            '0': '未开始',
            '1': '未完成',
            '2': '已完成',
            '3': '待确认'
          }
        },
        proNumber: {
          '0': '未开始',
          '1': '进行中',
          '2': '已完成'
        }
      }
    }
  },
  // 监听config是否有东西进来
  watch: {
    shou: {
      handler() {
        this.table_config.tableData = this.config.tableData
      }
    },
    taskid: {
      handler() {
        this.taskId = this.taskid
      }
    },
    config: {
      handler(newValue) {},
      // 初始化监听
      immediate: true
    }
  },
  created() {
    this.table_config = this.config
    this.taskId = this.taskid
  },
  mounted() {
    console.log(this.drawer.info, 'drawer.info')
  },
  methods: {
    getTypeTexts(type) {
      const typeTexts = {
        '0': '任务描述',
        '1': '任务讨论',
        '2': '自定义',
        '3': '完成文件',
        '4': '确认文件',
        '5': '驳回文件',
        '6': '撤回文件',
        '7': '终止文件',
        '8': '重启文件',
        '9': '项目描述',
        '10': '节点讨论',
        '11': '认领文件',
        '12': '催办文件',
        '13': '开始文件',
        '14': '流程节点',
        '15': '表单文件'
      }
      return [typeTexts[type] || '']
    },
    getStatusText(row) {
      if (row.taskType !== undefined && this.statusTexts.taskType[row.taskType]) {
        return this.statusTexts.taskType[row.taskType][row.status] || ''
      }
      if (row.proTypeId !== undefined && this.statusTexts.proTypeId[row.proTypeId]) {
        return this.statusTexts.proTypeId[row.proTypeId][row.status] || ''
      }
      if (row.proNumber !== undefined && this.statusTexts.proNumber[row.status]) {
        return this.statusTexts.proNumber[row.status] || ''
      }
      return ''
    },
    // 选择
    changeBox(sels) {
      this.sels = sels
      this.$emit('func', this.sels)
    },
    // 拉取子任务数据
    loadChiTask(tree, treeNode, resolve) {
      var page = 1
      var pageSize = 100
      var date = {
        proTypeFlag: '1',
        parentId: tree.id
      }
      // 子任务列表
      getTaskList(page, pageSize, date).then((data) => {
        if (data.code === 10000) {
          var list = data.result.list
          resolve(list)
        }
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 侧边栏关联任务
    dissociated(id) {
      this.$confirm('此操作将解除此关联任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var date = {
            taskId: this.taskId,
            objectId: id
          }
          delTaskRelation(date).then((data) => {
            if (data.code === 10000) {
              // this.$message.success('解除关联任务成功！')
              this.$emit('delTaskRelation')
            }
          }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // })
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消解除'
          // })
        })
    },
    // 侧边栏文件删除
    deleFile(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var date = {
            id: row.id
          }
          delFile(date).then((data) => {
            if (data.code === 10000) {
              // this.$message.success('文件删除成功！')
              this.$emit('delFile')
            }
          }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // })
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    // 侧边栏文件设置
    setFile(row) {
      this.$emit('setFile', row)
    },
    // 单元格方法
    returnName(obj) {
      if (obj.row.proNumber) {
        if (obj.column.label === '项目状态' && obj.row.status === '0') {
          return 'tableTextColor tableTextColor1'
        } else if (obj.column.label === '项目状态' && obj.row.status === '1') {
          return 'tableTextColor tableTextColor2'
        } else if (obj.column.label === '项目状态' && obj.row.status === '2') {
          return 'tableTextColor tableTextColor6'
        }
      } else {
        if (obj.column.label === '任务状态' && obj.row.taskType === '2001') {
          if (obj.row.status === '0') {
            return 'tableTextColor tableTextColor1'
          } else if (obj.row.status === '1') {
            return 'tableTextColor tableTextColor2'
          } else if (obj.row.status === '2') {
            return 'tableTextColor tableTextColor3'
          } else if (obj.row.status === '3') {
            return 'tableTextColor tableTextColor4'
          } else if (obj.row.status === '4') {
            return 'tableTextColor tableTextColor5'
          } else if (obj.row.status === '5') {
            return 'tableTextColor tableTextColor6'
          } else if (obj.row.status === '6') {
            return 'tableTextColor tableTextColor7'
          }
        } else if (this.tab !== 'todoTask' && obj.column.label === '任务状态' &&
        (obj.row.taskType === '0' || obj.row.taskType === '1')) {
          if (obj.row.status === '0') {
            return 'tableTextColor tableTextColor1'
          } else if (obj.row.status === '1') {
            return 'tableTextColor tableTextColor2'
          } else if (obj.row.status === '2') {
            return 'tableTextColor tableTextColor6'
          } else if (obj.row.status === '3') {
            return 'tableTextColor tableTextColor5'
          } else if (obj.row.status === '4') {
            return 'tableTextColor tableTextColor7'
          }
        } else if (this.tab !== 'todoTask' && obj.column.label === '任务状态' &&
        (obj.row.taskVo.taskType === '0' || obj.row.taskVo.taskType === '1')) {
          if (obj.row.taskVo.status === '0') {
            return 'tableTextColor tableTextColor1'
          } else if (obj.row.taskVo.status === '1') {
            return 'tableTextColor tableTextColor2'
          } else if (obj.row.taskVo.status === '2') {
            return 'tableTextColor tableTextColor6'
          } else if (obj.row.taskVo.status === '3') {
            return 'tableTextColor tableTextColor5'
          } else if (obj.row.taskVo.status === '4') {
            return 'tableTextColor tableTextColor7'
          }
        } else if (obj.column.label === '任务状态' && obj.row.taskType === '2001') {
          if (obj.row.taskVo.status === '0') {
            return 'tableTextColor tableTextColor1'
          } else if (obj.row.taskVo.status === '1') {
            return 'tableTextColor tableTextColor2'
          } else if (obj.row.taskVo.status === '2') {
            return 'tableTextColor tableTextColor3'
          } else if (obj.row.taskVo.status === '3') {
            return 'tableTextColor tableTextColor4'
          } else if (obj.row.taskVo.status === '4') {
            return 'tableTextColor tableTextColor5'
          } else if (obj.row.taskVo.status === '5') {
            return 'tableTextColor tableTextColor6'
          } else if (obj.row.taskVo.status === '6') {
            return 'tableTextColor tableTextColor7'
          }
        } else if (
          obj.column.label === '是否必填' &&
            obj.row.istaskField === '必填项'
        ) {
          return 'tableTextColor8'
        } else if (this.tab === 'todoTask' && obj.column.label === '任务状态' && obj.row.taskType === '1') {
          if (obj.row.todoStatus === '0') {
            return 'tableTextColor tableTextColor1'
          } else if (obj.row.todoStatus === '1') {
            return 'tableTextColor tableTextColor2'
          } else if (obj.row.todoStatus === '2') {
            return 'tableTextColor tableTextColor6'
          } else if (obj.row.todoStatus === '3') {
            return 'tableTextColor tableTextColor5'
          } else if (obj.row.todoStatus === '4') {
            return 'tableTextColor tableTextColor7'
          }
        } else if (this.tab === 'todoTask' && obj.column.label === '任务状态' && obj.row.taskType === '0') {
          if (obj.row.status === '0') {
            return 'tableTextColor tableTextColor1'
          } else if (obj.row.status === '1') {
            return 'tableTextColor tableTextColor2'
          } else if (obj.row.status === '2') {
            return 'tableTextColor tableTextColor6'
          } else if (obj.row.status === '3') {
            return 'tableTextColor tableTextColor5'
          } else if (obj.row.status === '4') {
            return 'tableTextColor tableTextColor7'
          }
        }
      }
    },
    cellStyle(data) {
      if (data) {
        return 'cursor:pointer;'
      }
    },

    /**
     * 复选框
     */
    handleSelectionChange(val) {
    },
    initConfig() {
      // 初始化配置
      for (const key in this.config) {
        // 判断keys 是不是存在  存在时替换
        if (Object.keys(this.table_config).includes(key)) {
          this.table_config[key] = this.config[key]
        }
      }
    },
    // 数据加载
    loadList() {
      // this.table_config.tableData = this.table_config.tableData.concat(this.table_config.tableData)
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 点击表格整行
    rowFun(row) {
      if (this.config.rowFun) {
        this.config.rowFun(row)
        localStorage.setItem('RowIndex', JSON.stringify(row.index))
        localStorage.setItem('Rowvalue', JSON.stringify(row))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index.scss';
::v-deep .el-table {
  position: absolute;
  width: 100%;
  height: 100%;
}
::v-deep .el-table .cell {
  display: flex;
  align-items: center;
  height: 38px;
  line-height: 38px !important;
}
::v-deep .el-table__body-wrapper {
  height: calc(100% - 55px)!important;
}
::v-deep .el-table .el-table__expand-icon {
  margin-left: -16px;
}
.scope-content-id {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}
::v-deep .el-table [class*='el-table__row--level'] .el-table__expand-icon {
  margin-right: 0px;
}
::v-deep .tableTextColor div span{
  font-size: $font_12;
  border-radius: 4px;
  line-height: 20px;
  padding: 2px 8px;
  display: inline-block;
  margin: auto;
}
::v-deep .tableTextColor8 div {
  line-height: 20px;
  padding: 2px 8px;
  display: inline-block;
  margin: auto;
  color: #fa7068;
}
// 未指派
.tableTextColor1 div span{
  color: #f1ad38;
  background: rgba(241, 173, 56, 0.1);
}
// 未完成
.tableTextColor2 div span{
  color: #74bf7a;
  background: rgba(116, 191, 122, 0.1);
}
// 待测试
.tableTextColor3 div span{
  color: #ff9c95;
  background: rgba(255, 156, 149, 0.1);
}
// 测试中
.tableTextColor4 div span{
  color: #fa7068;
  background: rgba(250, 112, 104, 0.1);
}
// 待确认
.tableTextColor5 div span{
  color: #8fb9ff;
  background: rgba(143, 185, 255, 0.1);
}
// 已完成
.tableTextColor6 div span{
  color: $color_main;
  background: rgba(40, 120, 255, 0.1);
}
// 已终止
.tableTextColor7 div span{
  color: #a8a8a8;
  background: rgba(168, 168, 168, 0.1);
}
.scpc-task-table {
  .scpc-operate-photos {
    // width: 30px;

    min-width: 30px;
    max-width: 50px;
    // border-radius: 50%;
    overflow: hidden;
  }
  .scope-content {
    width: 100%;
    display: flex;
    align-items: center;
    .scope-content-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
    }
    .scpc-operate-icon {
      flex: none;
    }
    .scpc-operate-icon:hover.liuchen_icon {
      display: inline-block;
    }
    .scpc-operate-photo {
        .img {
        width: 27px;
        height: 27px;
        font-size: $font_14;
        font-family: $font_family1;
        font-weight: 400;
        color: $color_white;
        line-height: 27px;
        text-align: center;
        background: $color_main;
        border-radius: 50%;
        margin-right: 10px;
      }
      div {
        img {
          width: 27px;
          height: 27px;
          border-radius: 50%;
          margin-right: 10px;
          vertical-align: middle;
        }
      }
    }
  }
}
.task_within {
  font-weight: 400;
  font-size: $font_12;
  padding: 1px 1px 0 1px;
  line-height: 14px;
  border-radius: 3px;
  color: #dd483f;
  background: $color_white;
  border: 1px solid #dd483f;
  margin-right: 10px;
}
::v-deep .el-table thead .el-table__cell {
  padding: 0 !important;
}
::v-deep.el-table__row:not([class*='el-table__row--level-']) {
  td:nth-child(2) {
    padding-left: 24px !important;
  }
}
::v-deep .el-table__placeholder{
margin-left: -15px !important;
}
::v-deep .el-table--border .el-table__cell {
  border-right: none;
}
// ::v-deep thead .el-table__cell{
//   border: 1px solid #EBEEF5;
// }
</style>
